import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BIN_ID = "690c6a6bae596e708f4805cb";
const MASTER_KEY = "$2a$10$vFa4BtnB1Nu1BUL6ukKdC.lLtW5/vwurJX3qGqj0CTcem.7tuWqyW";

function UserManager() {
  const [users, setUsers] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editUser, setEditUser] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // Fetch users from JSONBin
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await fetch(`https://api.jsonbin.io/v3/b/${BIN_ID}/latest`, {
        headers: { "X-Master-Key": MASTER_KEY },
      });
      const data = await res.json();
      setUsers(data.record || []);
    } catch (err) {
      console.error("Error fetching users:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Update JSONBin
  const updateBin = async (updatedList) => {
    try {
      await fetch(`https://api.jsonbin.io/v3/b/${BIN_ID}`, {
        method: "PUT",
        headers: {
          "X-Master-Key": MASTER_KEY,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedList),
      });
      setUsers(updatedList); // Update local state immediately
    } catch (err) {
      console.error("Error updating JSONBin:", err);
    }
  };

  // Delete a user
  const handleDelete = async (index) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;
    const updated = users.filter((_, i) => i !== index);
    setUsers(updated);
    await updateBin(updated);
  };

  // Edit start
  const handleEdit = (index) => {
    setEditIndex(index);
    setEditUser(users[index]);
  };

  // Save edited user
  const handleSave = async () => {
    if (editIndex === null) return;
    const updated = [...users];
    updated[editIndex] = editUser;
    setEditIndex(null);
    await updateBin(updated);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">

      {/* 🏠 Go to Main Page Button */}
      <button
        onClick={() => navigate("/main")}
        className="mb-6 bg-blue-600 text-white px-5 py-2 rounded-lg font-medium shadow-md hover:bg-blue-700 hover:shadow-lg transition-all duration-200"
      >
        🏠 Go to Main Page
      </button>

      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-semibold text-gray-800 flex items-center gap-2">
          <span className="text-lg">📋</span> Registered Users
        </h2>
        <button
          onClick={fetchUsers}
          className="bg-indigo-600 text-white text-sm px-3 py-2 rounded-md hover:bg-indigo-700 transition"
        >
          Refresh
        </button>
      </div>

      <div className="bg-white shadow rounded-lg overflow-hidden">
        {loading ? (
          <div className="p-6 text-center text-gray-600">Loading...</div>
        ) : users.length === 0 ? (
          <div className="p-6 text-center text-gray-600">No records found</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Name</th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Email</th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Mobile</th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Password</th>
                  <th className="px-4 py-3 text-center text-sm font-medium text-gray-600">Actions</th>
                </tr>
              </thead>

              <tbody className="bg-white divide-y divide-gray-100">
                {users.map((user, index) =>
                  editIndex === index ? (
                    <tr key={index} className="bg-gray-50">
                      <td className="px-4 py-3">
                        <input
                          className="w-full px-3 py-2 border rounded-md text-sm"
                          type="text"
                          value={editUser.name}
                          onChange={(e) => setEditUser({ ...editUser, name: e.target.value })}
                        />
                      </td>
                      <td className="px-4 py-3">
                        <input
                          className="w-full px-3 py-2 border rounded-md text-sm"
                          type="email"
                          value={editUser.email}
                          onChange={(e) => setEditUser({ ...editUser, email: e.target.value })}
                        />
                      </td>
                      <td className="px-4 py-3">
                        <input
                          className="w-full px-3 py-2 border rounded-md text-sm"
                          type="text"
                          value={editUser.mobile}
                          onChange={(e) => setEditUser({ ...editUser, mobile: e.target.value })}
                        />
                      </td>
                      <td className="px-4 py-3">
                        <input
                          className="w-full px-3 py-2 border rounded-md text-sm"
                          type="password"
                          value={editUser.password}
                          onChange={(e) => setEditUser({ ...editUser, password: e.target.value })}
                        />
                      </td>
                      <td className="px-4 py-3 text-center space-x-2">
                        <button
                          onClick={handleSave}
                          className="inline-flex items-center gap-2 px-3 py-2 bg-green-600 text-white rounded-md text-sm hover:bg-green-700 transition"
                        >
                          💾 Save
                        </button>
                        <button
                          onClick={() => setEditIndex(null)}
                          className="inline-flex items-center gap-2 px-3 py-2 bg-gray-200 text-gray-700 rounded-md text-sm hover:bg-gray-300 transition"
                        >
                          ❌ Cancel
                        </button>
                      </td>
                    </tr>
                  ) : (
                    <tr key={index}>
                      <td className="px-4 py-3 text-sm text-gray-700">{user.name}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{user.email}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{user.mobile}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{user.password}</td>
                      <td className="px-4 py-3 text-center">
                        <div className="inline-flex items-center gap-2">
                          <button
                            onClick={() => handleEdit(index)}
                            className="px-3 py-1 text-sm bg-yellow-100 text-yellow-800 rounded-md hover:bg-yellow-200 transition"
                          >
                            ✏️ Edit
                          </button>
                          <button
                            onClick={() => handleDelete(index)}
                            className="px-3 py-1 text-sm bg-red-100 text-red-800 rounded-md hover:bg-red-200 transition"
                          >
                            🗑 Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserManager;
